import { CheckCircle, Close } from '@mui/icons-material'
import { Box, CircularProgress, Modal, Typography } from '@mui/material'
import React from 'react'

const PaymentStatusPopup = ({ isLoading = false, iconStyles = {}, Icon, title, subtitle, Actions = () => { }, titleSx = {}, subTitleSx = {} }) => {
    return (
        <Box sx={{
            display: 'grid',
            //  flexDirection: 'column', 
            alignItems: 'center',
            gap: 1.5
        }}>
            {/* Render Custom Icon with styles if provided, otherwise show default CheckCircleIcon */}
            {isLoading ? <CircularProgress sx={(theme) => ({
                fontSize: 56, mb: 1, color: theme.palette.customColors.b300,
                marginInline: "auto"
                , ...iconStyles
            })} /> : React.isValidElement(Icon) ? (
                React.cloneElement(Icon, {
                    sx: {
                        fontSize: 56, mb: 1, color: "#4CAF50",
                        marginInline: "auto"
                        , ...iconStyles
                    },
                })
            ) : (
                <CheckCircle
                    sx={{
                        fontSize: 56,
                        mb: 1,
                        color: "#4CAF50",
                        marginInline: "auto",
                        ...iconStyles, // Apply custom styles
                    }}
                />
            )}

            <Typography variant="h4" component="h2" sx={{
                fontWeight: 600, mb: 1,
                ...titleSx
                //  textAlign: "start"
            }}>
                {title}
            </Typography>

            <Typography variant="body1" sx={{
                color: 'text.secondary', mb: 2,
                ...subTitleSx
                // textAlign: 'start'
            }}>
                {subtitle ? (
                    subtitle
                ) : (
                    <>
                        Your payment has been processed and subscription plan has been upgraded.
                    </>
                )}
            </Typography>

            {/* <Button
                variant="contained"
                sx={{
                    bgcolor: 'black',
                    color: 'white',
                    borderRadius: 1,
                    px: 3,
                    '&:hover': {
                        bgcolor: '#333',
                    },
                    width: "max-content"
                }}
                onClick={Actions || onClose}
            >
                {ActionText}
            </Button> */}
            <Actions />
        </Box>
    )
}

export default PaymentStatusPopup
